var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPinSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17402 0.326599C3.65381 0.326599 0.782715 3.19769 0.782715 6.7179C0.782715 9.92782 3.17232 12.5778 6.26098 13.0236V21.3266H8.08706V13.0236C11.1757 12.5778 13.5653 9.92782 13.5653 6.7179C13.5653 3.19769 10.6942 0.326599 7.17402 0.326599ZM7.17402 3.06573C5.16604 3.06573 3.52185 4.70992 3.52185 6.7179H5.34793C5.34793 5.69786 6.15398 4.89182 7.17402 4.89182V3.06573Z",
    fill: "#563424"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinSolid);
export default __webpack_public_path__ + "static/media/map-pin-solid.f112e1c1aabd29a065d9aab0c7903bbf.svg";
export { ForwardRef as ReactComponent };